import React from 'react';
import './TextModal.css';
import { CloseIcon } from '../../assets/icons';

interface TextModalProps {
  title: string;
  description: string;
  isVisible: boolean;
  onClose: () => void;
}

export const TextModal: React.FC<TextModalProps> = ({ 
  title, 
  description, 
  isVisible, 
  onClose 
}) => {
  if (!isVisible) return null;

  return (
    <div className="text-modal-backdrop">
      <div className="text-modal-container">
        <div className="text-modal-header">
          <h2 className="text-modal-title">{title}</h2>
          <button 
            className="text-modal-close-button" 
            onClick={onClose}
            aria-label="Fechar"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="text-modal-scroll-container">
          <div className="text-modal-description" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </div>
  );
};